import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './AudioDeviceInput.scss';
import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import useProject from '../../../hooks/useProject';

const AudioDeviceInput = () => {
  const { t } = useTranslation();
  const [devices, setDevices] = useState<Option[]>([{ text: 'None', value: '0' }]);
  const { project, updateStream } = useProject();

  const getDevices = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });

      const deviceList = await navigator.mediaDevices.enumerateDevices();
      const audioInputs = deviceList.filter((device) => device.kind === 'audioinput');

      const options: Option[] = [{ text: 'None', value: '0' }];
      audioInputs.forEach((device) => {
        options.push({ text: device.label || 'Unknown Device', value: device.deviceId });
      });

      setDevices(options);
    } catch (error) {
      console.error('Error fetching audio devices:', error);
    }
  };

  useEffect(() => {
    getDevices();

    navigator.mediaDevices.addEventListener('devicechange', getDevices);
    return () => {
      navigator.mediaDevices.removeEventListener('devicechange', getDevices);
    };
  }, []);

  const onChange = (option: Option) => {
    const audioDevice = `${option.text}:${option.value}`;

    if (audioDevice !== project.stream.audioDevice) {
      updateStream({ audioDevice: audioDevice});
    }
  };

  return (
    <div className="audio-device-input">
      <div className="input-title">{t('producer.inputs.audio-device.title')}</div>
      <Dropdown
        value={project.stream.audioDeviceId}
        options={devices}
        onChange={onChange}
        placeholderKey="producer.inputs.audio-device.placeholder"
        readonly={false}
      />
      <div className="input-component-footer">{t('producer.inputs.audio-device.footer')}</div>
    </div>
  );
};

export default React.memo(AudioDeviceInput);
